module.exports = msal;


//////////////////
// WEBPACK FOOTER
// external "msal"
// module id = 372
// module chunks = 2